export default "__VITE_ASSET__Cbvc9PlJ__"